import { render } from "./IconArchiveBox.vue?vue&type=template&id=1dd75d98"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconArchiveBox.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1dd75d98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1dd75d98', __exports__)) {
    api.reload('1dd75d98', __exports__)
  }
  
  module.hot.accept("./IconArchiveBox.vue?vue&type=template&id=1dd75d98", () => {
    api.rerender('1dd75d98', render)
  })

}


export default __exports__